
window.lookupEnabledCountries_IDs =   ['1'             , '4'      ];
window.lookupEnabledCountries_Names = ['United Kingdom', 'Ireland'];

window.postcodeOptionalOnChooseProductCountries_IDs =   [];
window.postcodeOptionalOnChooseProductCountries_Names = [];

window.postcodeMandatoryOnPaymentCountries_IDs =   ['1'             , '4'      ];
window.postcodeMandatoryOnPaymentCountries_Names = ['United Kingdom', 'Ireland'];
